import React, { useEffect, useState } from 'react';
import {
  Routes,
  Route,
  useLocation, Navigate,
} from 'react-router-dom';
import ReactGA from 'react-ga4';

// Import pages
import Dashboard from '../pages/dashboard/dashboard';
import SwapsContainer from '../pages/swaps/swaps-container';
import Sidebar from './sidebar';
import Settings from '../pages/settings/settings';
import Header from './header';
import Support from '../pages/support/support';
import Learn from '../pages/learn/learn';
import Feedback from '../pages/feedback/feedback';
import Tour from 'reactour';
import WelcomeModal, { useWelcomeModal } from './welcome-modal';
import CreateNeofaceWizard from '../pages/create-neoface/create-neoface-wizard';
import MyNeofaces from '../pages/my-neofaces/my-neofaces';

function AppHome() {
  const location = useLocation();
  const welcomeModal = useWelcomeModal();
  // const [isTourOpen, setIsTourOpen] = useState(true);

  useEffect(() => {
    // Initialize GA4
    const isProd = import.meta.env.PROD;
    if (isProd) {
      ReactGA.initialize('G-80T89R0NX6');
    }
  }, []);


  useEffect(() => {
    const html = document.querySelector('html');
    if (html) {
      html.style.scrollBehavior = 'auto';
      window.scroll({ top: 0 });
      html.style.scrollBehavior = '';
    }
  }, [location.pathname]);

  return (
    <div className='flex h-[100dvh] overflow-hidden'>
      {/*<Tour*/}
      {/*  steps={steps}*/}
      {/*  isOpen={isTourOpen}*/}
      {/*  onRequestClose={() => setIsTourOpen(false)}*/}
      {/*  accentColor="#5cb85c" // Optional: customize accent color*/}
      {/*/>*/}
      <WelcomeModal
        isOpen={welcomeModal.isOpen}
        onClose={welcomeModal.onClose}
      />
      <Sidebar />

      {/* Content Area */}
      <div className='relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden'>

        {/* Header */}
        <Header />

        <main className='grow py-10 px-6 md:px-12'>
          <div className='max-w-[96rem] mx-auto'>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" />} />
              <Route path='/dashboard' element={<Dashboard />} />
              <Route path='/create-neoface' element={<CreateNeofaceWizard />} />
              <Route path='/my-neofaces' element={<MyNeofaces />} />
              <Route path='/anonymize-content' element={<SwapsContainer />} />
              <Route path='/settings' element={<Settings />} />
              <Route path='/learn' element={<Learn />} />
              <Route path='/support' element={<Support />} />
              <Route path='/feedback' element={<Feedback  />} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
);
}

export default AppHome;
